import Header from '@Common/Header.vue';
import VerticalHeader from '@Common/VerticalHeader.vue';

const securityProfiles = process.env.SECURITY_PROFILE.split(",")

const Admin = resolve => {
    require.ensure(['./components/pages/admin/Admin.vue'], () => {
        resolve(require('./components/pages/admin/Admin.vue'))
    }, 'Admin')
}

const UserProfile = resolve => {
    require.ensure(['./components/pages/user/UserProfile.vue'], () => {
        resolve(require('./components/pages/user/UserProfile.vue'))
    }, 'UserProfile')
}

const Clients = resolve => {
    require.ensure(['./components/pages/client/ClientsIndex.vue'], () => {
        resolve(require('./components/pages/client/ClientsIndex.vue'))
    }, 'Clients')
}

const Client = resolve => {
    require.ensure(['./components/pages/client/Client.vue'], () => {
        resolve(require('./components/pages/client/Client.vue'))
    }, 'Client')
}

const ClientDelete = resolve => {
    require.ensure(['./components/pages/client/ClientDelete.vue'], () => {
        resolve(require('./components/pages/client/ClientDelete.vue'))
    }, 'ClientDelete')
}


const Cases = resolve => {
    require.ensure(['./components/pages/case/CasesIndex.vue'], () => {
        resolve(require('./components/pages/case/CasesIndex.vue'))
    }, 'Cases')
}

const DOGCases = resolve => {
    require.ensure(['./components/pages/dog/DOGCasesIndex.vue'], () => {
        resolve(require('./components/pages/dog/DOGCasesIndex.vue'))
    }, 'DOGCases')
}

//Loss Calculator Section
const LossCalulator = resolve => {
    require.ensure(['./components/pages/loss/LossCalculator.vue'], () => {
        resolve(require('./components/pages/loss/LossCalculator.vue'))
    }, 'LossCalculator')
}

const LossRuns = resolve => {
    require.ensure(['./components/pages/loss/LossRuns.vue'], () => {
        resolve(require('./components/pages/loss/LossRuns.vue'))
    }, 'LossRuns')
}

const LossOverviewDisplay = resolve => {
    require.ensure(['./components/pages/loss/LossOverviewDisplay.vue'], () => {
        resolve(require('./components/pages/loss/LossOverviewDisplay.vue'))
    }, 'LossOverviewDisplay')
}

const LossReport = resolve => {
    require.ensure(['./components/pages/loss/LossReport.vue'], () => {
        resolve(require('./components/pages/loss/LossReport.vue'))
    }, 'LossReport')
}





const DogHoldings = resolve => {
    require.ensure(['./components/pages/dog/DOGHoldings.vue'], () => {
        resolve(require('./components/pages/dog/DOGHoldings.vue'))
    }, 'DogHoldings')
}

const Securities = resolve => {
    require.ensure(['./components/pages/data-panel/Securities.vue'], () => {
        resolve(require('./components/pages/data-panel/Securities.vue'))
    }, 'Securities')
}

const SecuritiesSquash = resolve => {
    require.ensure(['./components/pages/data-panel/SecuritiesSquash.vue'], () => {
        resolve(require('./components/pages/data-panel/SecuritiesSquash.vue'))
    }, 'SecuritiesSquash')
}

const SecuritiesIngestion = resolve => {
    require.ensure(['./components/pages/data-panel/SecuritiesIngestion.vue'], () => {
        resolve(require('./components/pages/data-panel/SecuritiesIngestion.vue'))
    }, 'SecuritiesIngestion')
}

const Accounts = resolve => {
    require.ensure(['./components/pages/data-panel/Accounts.vue'], () => {
        resolve(require('./components/pages/data-panel/Accounts.vue'))
    }, 'Accounts')
}


const SecurityDrops = resolve => {
    require.ensure(['./components/pages/finance/SecurityDrops.vue'], () => {
        resolve(require('./components/pages/finance/SecurityDrops.vue'))
    }, 'SecurityDrops')
}

const Discrepancy = resolve => {
    require.ensure(['./components/pages/finance/Discrepancy.vue'], () => {
        resolve(require('./components/pages/finance/Discrepancy.vue'))
    }, 'Discrepancy')
}

const ObjectDetail = resolve => {
    require.ensure(['./components/pages/finance/ObjectDetail.vue'], () => {
        resolve(require('./components/pages/finance/ObjectDetail.vue'))
    }, 'ObjectDetail')
}

const Holdings13f = resolve => {
    require.ensure(['./components/pages/SEC-13f/13fHoldings.vue'], () => {
        resolve(require('./components/pages/SEC-13f/13fHoldings.vue'))
    }, 'Holdings13f')
}

const Losses13f = resolve => {
    require.ensure(['./components/pages/SEC-13f/Losses13F.vue'], () => {
        resolve(require('./components/pages/SEC-13f/Losses13F.vue'))
    }, 'Holdings13f')
}

const Holdings = resolve => {
    require.ensure(['./components/pages/finance/HoldingsPage.vue'], () => {
        resolve(require('./components/pages/finance/HoldingsPage.vue'))
    }, 'Holdings')
}

const IngestionPanel = resolve => {
    require.ensure(['./components/pages/ingestion/IngestionPanel.vue'], () => {
        resolve(require('./components/pages/ingestion/IngestionPanel.vue'))
    }, 'IngestionPanel')
}

const SkippedFiles = resolve => {
    require.ensure(['./components/pages/ingestion/SkippedFiles.vue'], () => {
        resolve(require('./components/pages/ingestion/SkippedFiles.vue'))
    }, 'SkippedFiles')
}

const StagedFiles = resolve => {
    require.ensure(['./components/pages/ingestion/StagedFiles.vue'], () => {
        resolve(require('./components/pages/ingestion/StagedFiles.vue'))
    }, 'StagedFiles')
}

const IngestedFiles = resolve => {
    require.ensure(['./components/pages/ingestion/IngestedFiles.vue'], () => {
        resolve(require('./components/pages/ingestion/IngestedFiles.vue'))
    }, 'IngestedFiles')
}

const IngestionTracker = resolve => {
    require.ensure(['./components/pages/ingestion/IngestionTracker.vue'], () => {
        resolve(require('./components/pages/ingestion/IngestionTracker.vue'))
    }, 'IngestionTracker')
}

const Case = resolve => {
    require.ensure(['./components/pages/case/Case.vue'], () => {
        resolve(require('./components/pages/case/Case.vue'))
    }, 'Case')
}

const Calendar = resolve => {
    require.ensure(['./components/pages/calendar/Calendar.vue'], () => {
        resolve(require('./components/pages/calendar/Calendar.vue'))
    }, 'Calendar')
}

const QuarterlyReports = resolve => {
    require.ensure(['./components/pages/reports/QuarterlyReports.vue'], () => {
        resolve(require('./components/pages/reports/QuarterlyReports.vue'))
    }, 'QuarterlyReports')
}

const ScorecardReport = resolve => {
    require.ensure(['./components/pages/reports/ScorecardReport.vue'], () => {
        resolve(require('./components/pages/reports/ScorecardReport.vue'))
    }, 'ScorecardReport')
}

const AnnualReport = resolve => {
    require.ensure(['./components/pages/reports/AnnualReport.vue'], () => {
        resolve(require('./components/pages/reports/AnnualReport.vue'))
    }, 'AnnualReport')
}

// Client Management & Reporting

const ReportsIndex = resolve => {
    require.ensure(['./components/pages/reports/ReportsIndex.vue'], () => {
        resolve(require('./components/pages/reports/ReportsIndex.vue'))
    }, 'ReportsMain')
}

const ReportGenerator = resolve => {
    require.ensure(['./components/pages/reports/ReportGenerator.vue'], () => {
        resolve(require('./components/pages/reports/ReportGenerator.vue'))
    }, 'ReportsMain')
}


const NewsFeedManagement = resolve => {
    require.ensure(['./components/pages/news-feed/NewsFeedManagement.vue'], () => {
        resolve(require('./components/pages/news-feed/NewsFeedManagement.vue'))
    }, 'NewsFeedManagement')
}

const Docket = resolve => {
    require.ensure(['./components/pages/docket/Dockets.vue'], () => {
        resolve(require('./components/pages/docket/Dockets.vue'))
    }, 'Dockets')
}




const Forbidden = resolve => {
    require.ensure(['./components/Forbidden.vue'], () => {
        resolve(require('./components/Forbidden.vue'))
    }, 'Forbidden')
}

const Login = resolve => {
    require.ensure(['./components/Login.vue'], () => {
        resolve(require('./components/Login.vue'))
    }, 'Login')
}

const OktaLogin = resolve => {
    require.ensure(['./components/OktaLogin.vue'], () => {
        resolve(require('./components/OktaLogin.vue'))
    }, 'OktaLogin')
}

const NavigationPage = resolve => {
    require.ensure(['./components/NavigationPage.vue'], () => {
        resolve(require('./components/NavigationPage.vue'))
    }, 'NavigationPage');
}

const PageNotFound = resolve => {
    require.ensure(['./components/PageNotFound.vue'], () => {
        resolve(require('./components/PageNotFound.vue'))
    }, 'PageNotFound')
}

const SideMenu = resolve => {
    require.ensure(['./components/common/SideMenu.vue'], () => {
        resolve(require('./components/common/SideMenu.vue'))
    }, 'SideMenu')
}

const Trades = resolve => {
    require.ensure(['./components/pages/finance/TradesPage.vue'], () => {
        resolve(require('./components/pages/finance/TradesPage.vue'))
    }, 'Trades')
}

const ForeignTrades = resolve => {
    require.ensure(['./components/pages/finance/ForeignTradesPage.vue'], () => {
        resolve(require('./components/pages/finance/ForeignTradesPage.vue'))
    }, 'ForeignTrades')
}

const Updates = resolve => {
    require.ensure(['./components/Updates.vue'], () => {
        resolve(require('./components/Updates.vue'))
    }, 'Updates')
}

const Motions = resolve => {
    require.ensure(['./components/pages/motion/MotionsIndex.vue'], () => {
        resolve(require('./components/pages/motion/MotionsIndex.vue'))
    }, 'Motions')
}

const HowToVideos = resolve => {
    require.ensure(['./components/pages/help/HowToVideos.vue'], () => {
        resolve(require('./components/pages/help/HowToVideos.vue'))
    }, 'HowToVideos')
}

const TxnSearch = resolve => {
    require.ensure(['./components/pages/reports/TxnSearch.vue'], () => {
        resolve(require('./components/pages/reports/TxnSearch.vue'))
    }, 'TxnSearch')
}



export const routes = [
    {
        path: '/updates',
        name: 'Updates',
        components: {
            default: NavigationPage,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/admin',
        name: 'Admin Panel',
        meta: {
            requiresAdmin: true,
        },
        components: {
            default: Admin,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/clients',
        name: 'Clients',
        components: {
            default: Clients,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/clients/client/:clientID/:subPage?',
        name: 'Client',
        components: {
                default: Client,
                'header-vertical': VerticalHeader,
                'header-top': Header,
                'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/clientDelete',
        name: 'ClientDelete',
        components: {
            default: ClientDelete,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/cases',
        alias: '/',
        name: 'Case List',
        components: {
            default: Cases,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/cases/case/:caseId/:subPage?',
        name: 'Case',
        components: {
                default: Case,
                'header-vertical': VerticalHeader,
                'header-top': Header,
                'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/DOGCases',
        name: 'DOG Cases',
        components: {
              default: DOGCases,
              'header-vertical': VerticalHeader,
              'header-top': Header,
              'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },

    //Loss Calculator Routes

    {
        path: '/lossCalculator',
        name: 'Loss Calculator',
        components: {
            default: LossCalulator,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/lossRuns',
        name: 'Loss Runs',
        components: {
            default: LossRuns,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/lossOverview',
        name: 'Loss Overview',
        components: {
            default: LossOverviewDisplay,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/lossReport/:subPage?',
        name: 'Loss Report',
        components: {
            default: LossReport,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        props: true,
        meta:{
            requiresAuth: true
        }
    },

    {
        path: '/dockets',
        name: 'Dockets',
        components: {
                default: Docket,
                'header-vertical': VerticalHeader,
                'header-top': Header,
                'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/motions',
        name: 'Motions',
        components: {
                default: Motions,
                'header-vertical': VerticalHeader,
                'header-top': Header,
                'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/securities',
        name: 'Securities',
        components: {
                default: Securities,
                'header-vertical': VerticalHeader,
                'header-top': Header,
                'side-menu': SideMenu
        },
        props: true,
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/securitiesSquash',
        name: 'SecuritiesSquash',
        components: {
                default: SecuritiesSquash,
                'header-vertical': VerticalHeader,
                'header-top': Header,
                'side-menu': SideMenu
        },
        props: true,
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/securitiesIngestion',
        name: 'SecuritiesIngestion',
        components: {
                default: SecuritiesIngestion,
                'header-vertical': VerticalHeader,
                'header-top': Header,
                'side-menu': SideMenu
        },
        props: true,
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/accounts',
        name: 'Accounts',
        components: {
                default: Accounts,
                'header-vertical': VerticalHeader,
                'header-top': Header,
                'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/calendar',
        name: 'Calendar',
        props: true,
        components: {
                default: Calendar,
                'header-vertical': VerticalHeader,
                'header-top': Header,
                'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/client-management/reports',
        name: 'Reports',
        components: {
                default: ReportsIndex,
                'header-vertical': VerticalHeader,
                'header-top': Header,
                'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/client-management/reportGenerator',
        name: 'Report Generator',
        components: {
                default: ReportGenerator,
                'header-vertical': VerticalHeader,
                'header-top': Header,
                'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/client-management/reportGenerator/:subPage?',
        name: 'Reports',
        components: {
            default: ReportGenerator,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        props: true,
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/client-management/news-feed',
        name: 'News Feed Management',
        components: {
                default: NewsFeedManagement,
                'header-vertical': VerticalHeader,
                'header-top': Header,
                'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/discrepancy',
        name: "Holding-Trade Discrepancies",
        components: {
            default: Discrepancy,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/forbidden',
        name: 'Forbidden',
        components: {
            default: Forbidden,
        }
    },
    {
        path: '/login',
        name: 'Login Page',
        components: {
            default: securityProfiles.includes('security-okta') ? OktaLogin : Login
        },
        meta: {
            doesNotRequireLogin: true,
        }
    },
    {
        path: '/trades',
        name: 'Trades Page',
        components: {
            default: Trades,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        props:true,
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/foreignTrades',
        name: 'Foreign Trades Page',
        components: {
            default: ForeignTrades,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        props:true,
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/trades/:tableType/:id',
        name: 'Trade Detail',
        components: {
            default: ObjectDetail,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        props:true,
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/holdings',
        name: 'Holdings Page',
        components: {
            default: Holdings,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/holdings/:tableType/:id',
        name: 'Holding Detail',
        components: {
            default: ObjectDetail,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        props:true,
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/dogHoldings',
        name: 'DOG Holdings',
        components: {
            default: DogHoldings,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/13f/holdings',
        name: '13F Holdings',
        components: {
            default: Holdings13f,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/13f/losses',
        name: '13F Loss Analyzer',
        components: {
            default: Losses13f,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/securityDrops',
        name: 'Security Price Drops',
        components: {
            default: SecurityDrops,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/ingestion',
        name: 'Ingestion Panel',
        components: {
            default: IngestionPanel,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/skippedFiles',
        name: 'Skipped Files',
        components: {
            default: SkippedFiles,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/stagedFiles',
        name: 'Staged Files',
        components: {
            default: StagedFiles,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/ingestedFiles',
        name: 'Ingested Files',
        components: {
            default: IngestedFiles,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/ingestionTracker',
        name: 'Ingestion Tracker',
        components: {
            default: IngestionTracker,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/userProfile',
        name: 'User Profile',
        components: {
            default: UserProfile,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/howto',
        name: 'How To Videos',
        components: {
            default: HowToVideos,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },

    //Logout

    {
        path: '/pageNotFound',
        name: 'Page Not Found',
        components: {
            default: PageNotFound,
        }
    },
    {
        path: '*',
        redirect: '/pageNotFound'
    },
    {
        path: '/txnSearch',
        name: 'Transaction or Holding Search',
        components: {
                default: TxnSearch,
                'header-vertical': VerticalHeader,
                'header-top': Header,
                'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    }
];


